module.exports = __webpack_public_path__ + "img/023-vampire.37112d52.png";